import { useRouter } from 'next/router';
import React from 'react';
import { Translate } from '~/i18n';
import { WhatsappIcon } from '~/svgs/contact';
import Button from './button';

const WhatsappContactButton = () => {
   const router = useRouter();

   const redirect = () => {
      router.push('https://wa.me/966535050833');
   };

   return (
      <Button
         onClick={redirect}
         className="!h-12 w-full !bg-white flex items-center !shadow-none !border-[#AFB5BC] sm:px-4 px-2">
         <WhatsappIcon className="w-6 h-6 sm:w-7 sm:h-7" />
         <div className="sm:text-base text-sm mx-auto">
            <b className="text-primary-color">
               <Translate id="contact:need help" />{' '}
            </b>
            <span className="text-gray-600 whitespace-nowrap">
               <Translate id="contact:chat with customer support" />
            </span>
         </div>
      </Button>
   );
};

export default WhatsappContactButton;
